export const timeZoneOptions = [
	{ value: 'Pacific/Honolulu', label: 'Hawaii Standard Time (HST)' },
	{ value: 'America/Anchorage', label: 'Alaska Standard Time (AKST)' },
	{ value: 'America/Los_Angeles', label: 'Pacific Standard Time (PST)' },
	{ value: 'America/Denver', label: 'Mountain Standard Time (MST)' },
	{ value: 'America/Chicago', label: 'Central Standard Time (CST)' },
	{ value: 'America/New_York', label: 'Eastern Standard Time (EST)' }
]

export const timeZonesOptionsShort = [
	{ value: 'Pacific/Honolulu', label: 'HST' },
	{ value: 'America/Anchorage', label: 'AKST' },
	{ value: 'America/Los_Angeles', label: 'PST' },
	{ value: 'America/Denver', label: 'MST' },
	{ value: 'America/Chicago', label: 'CST' },
	{ value: 'America/New_York', label: 'EST' }
]
